module.exports = __webpack_public_path__ + "fonts/Poppins-Regular.387f900.woff";